import NewAnotationModal from "./AnotationModal/AnotationModal";
import NewMessageFavoriteModal from "./MessageFavModal/MessageFavModal";
import NewFileShareModal from "./FileShareModal/FileShareModal";
import InteractionsHistoricModal from "./InteractionsHistoricModal/InteractionsHistoricModal";

const ModalsDetails = {
  NewAnotationModal,
  NewMessageFavoriteModal,
  NewFileShareModal,
  InteractionsHistoricModal,
};

export default ModalsDetails;
